import type { TableFilterTreeOptions } from "../table-filter.type";

import { useReferentialLoggableModels } from "@/entities/referential/referential-models";

export const useTableFilterSubjectType = (): TableFilterTreeOptions => {
  const { models } = useReferentialLoggableModels();

  return {
    filterMode: "tree",
    filters: models.map((model) => ({
      text: model.name,
      // TODO DEV-8365 use `model.slug` instead of fqcn/classPath when ready
      value: model.fqcn,
    })),
  };
};
